import { cellRenderParseData } from '../../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'accountingDate',
    caption: 'Дата СК(ГП)',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'length',
    caption: 'Длина',
    dataType: 'number',
    notVisible: true
  },
  {
    dataField: 'mark',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'normativeDoc',
    caption: 'Нормативный документ',
    dataType: 'string'
  },
  {
    dataField: 'operationNumId',
    caption: 'ID операции',
    dataType: 'integer',
    notVisible: true
  },
  {
    dataField: 'pieceId',
    caption: '№ УЕ',
    dataType: 'string'
  },
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ ПФ',
    dataType: 'integer'
  },
  {
    dataField: 'profileSize',
    caption: 'Профилеразмер',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ (ГП)',
    dataType: 'string'
  },
  {
    dataField: 'qcId',
    caption: 'СК(ГП)',
    dataType: 'string'
  },
  {
    dataField: 'thickness',
    caption: 'Толщина',
    dataType: 'number'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во, теор.',
    dataType: 'number'
  },
  {
    dataField: 'quantityOff',
    caption: 'Кол-во, факт.',
    dataType: 'string'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Позиция заказа',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderId',
    caption: 'Заказ ZDVl',
    dataType: 'integer'
  },
  {
    dataField: 'taskNumber',
    caption: 'Номер задания',
    dataType: 'string'
  },
  {
    dataField: 'mountingDate',
    caption: 'Дата монтажа',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default columnDataGrid;
